var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row margin-top" }, [
        _c("div", { staticClass: "col-8 offset-2" }, [
          _c("div", { staticClass: "row medium-font" }, [
            _c("div", { staticClass: "col-3" }, [
              _c("a", { attrs: { href: "#" } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 text-center" }, [
              _c("h3", [
                _c("strong", [_vm._v("Grow your business with mod24")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row big-font" }, [
            _c("div", { staticClass: "col text-center" }, [
              _c("p", [
                _c("strong", [
                  _vm._v(
                    "\n              A new confirmation link has been sent to your email\n            "
                  )
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-8 offset-2 background text-center" }, [
          _vm._v(
            "\n      Please check your email inbox and click on the confirmation link.\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-8 offset-2" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col text-right" }, [
              _c("a", { staticClass: "thick-font", attrs: { href: "#" } }, [
                _vm._v("Need help?")
              ]),
              _c("br"),
              _vm._v(" "),
              _c("p", { staticClass: "info-text" }, [
                _vm._v("Visit our knowledge base")
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d1538016", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1538016","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/VerificationEmailResent.vue
// module id = null
// module chunks = 